window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*= =============== Helpers ================ */
theme.config = {
  devMode: window.theme.devMode || false, // default false if not found
  qaMode: window.theme.qaMode || false,
  breakpoints: {
    mobile: '(min-width: 600px)',
    smallmobile: '(max-width: 399px)',
    mediumUp: '(min-width: 750px)',
    medium: '(min-width: 750px) and (max-width: 894px)',
    largeUp: '(min-width: 1100px)',
    desktop: '(min-width: 1400px)'
  },
  classList: {
    active: 'active',
    show: 'show',
    hide: 'hide',
    noscroll: 'noscroll'
  }
};

/*  These are kept outside of theme.helpers so it
    can be written as consolelog rather than
    theme.helpers.consolelog
*/
const consolelog = (message, qa = false) => {
  const devModeActive = theme.config.devMode;
  const qaModeActive = theme.config.qaMode;
  let log = false;
  let newMessage = message;

  if (qaModeActive && qa !== false) {
    log = true;
    newMessage = `QA: ${message}`;
  } else if (devModeActive) {
    log = true;
  }

  if (log) {
    // eslint-disable-next-line no-console
    console.log(newMessage);
  }
};

const QAlog = message => {
  consolelog(message, true);
};


// eslint-disable-next-line func-names
theme.helpers = (function () {
  /*  Stops accidental consolelogs when devmode
      has been turned on in Customiser.
  */
  const devLog = (module, functionName) => {
    consolelog(`${module}: ${functionName}`);
  };

  /*  Runs through all the classes, inc. mutlis
      to see if any exist, if not, returns false
  */
  const foundSelector = selectorObj => {
    let selectorFound = false;
    const identifier = document.querySelector(selectorObj);
    // consolelog(`identifier: ${identifier}`);
    if (identifier != null) {
      selectorFound = true;
    }
    return selectorFound;
  };

  /*  Runs through all the classes, inc. mutlis
      to see if any exist, if not, returns false
  */
  const foundSelectors = selectorsObj => {
    let selectorsFound = false;

    Array.from(Object.keys(selectorsObj)).forEach(key => {
      if (selectorsFound === false && key !== 'siteBody' && key !== 'bodyWrapper') {
        const identifier = selectorsObj[key];
        let findingIdentifier;
        if (key === 'multi') {
          Array.from(Object.keys(identifier)).forEach(multiKey => {
            if (selectorsFound === false) {
              const multiidentifier = identifier[multiKey];
              findingIdentifier = document.querySelector(multiidentifier);
              if (findingIdentifier != null) {
                QAlog(`findingmultiIdentifier: ${key}`);
                selectorsFound = true;
              }
            }
          });
        } else {
          findingIdentifier = document.querySelector(identifier);
        }
        // need to remove globals from here otherwise it'll always come back as "found"
        if (findingIdentifier != null) {
          QAlog(`findingIdentifier: ${key}`);
          selectorsFound = true;
        }
      }
    });

    return selectorsFound;
  };

  /*  Takes the selectors, and passes them back as
      actually usable stuff
  */
  // eslint-disable-next-line func-names
  const SelectorsReturned = function (selectorsObj) {
    const selectorsObjReturned = {};
    const selectorsObjReturnedMulti = {};

    // Array.from(Object.keys(selectorsObj)).forEach((key, identifier) => {
    //   if (key === 'multi') {
    //     Array.from(Object.keys(identifier)).forEach((multiKey, multiIdentifier) => {
    //       selectorsObjReturnedMulti[multiKey] = document.querySelectorAll(multiIdentifier);
    //     });
    //   } else {
    //     selectorsObjReturned[key] = document.querySelector(identifier);
    //   }
    // });
    for (const [key, identifier] of Object.entries(selectorsObj)) {
      if (key === 'multi') {
        for (const [multiKey, multiIdentifier] of Object.entries(identifier)) {
          selectorsObjReturnedMulti[multiKey] = document.querySelectorAll(multiIdentifier);
        }
      } else {
        selectorsObjReturned[key] = document.querySelector(identifier);
      }
    }
    if (selectorsObjReturnedMulti) {
      selectorsObjReturned.multi = selectorsObjReturnedMulti;
    }
    return selectorsObjReturned;

    // for (const [key, identifier] of Object.entries(selectorsObj)) {
    //   if (key === 'multi') {
    //     for (const [multiKey, multiIdentifier] of Object.entries(identifier)) {
    //       selectorsObjReturnedMulti[multiKey] = document.querySelectorAll(multiIdentifier);
    //     }
    //   } else {
    //     selectorsObjReturned[key] = document.querySelector(identifier);
    //   }
    // }
    // if (selectorsObjReturnedMulti) {
    //   selectorsObjReturned.multi = selectorsObjReturnedMulti;
    // }
    // return selectorsObjReturned;
  };

  /*  Gets the classList and puts it into one array
      to use elsewhere. Example is offscreen closes
      all classes, so instead of adding each one,
      pass into this instead. Check offscreen.js
  */
  const classListMerged = classList => {
    const selectorsString = [];
    Array.from(Object.keys(classList)).forEach(key => {
      const arr = classList[key].toString();
      selectorsString.push(arr);
    });

    return selectorsString;
  };

  /*  Returns true or false depending if the elem
      is in view or not
  */
  const isInViewport = elem => {
    const bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0
      && bounding.left >= 0
      && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  /*  Returns true or false depending if the elem
      has the class or not
  */
  const hasClass = (element, className) => {
    if (element.classList.contains(className)) {
      return true;
    }
    return false;
  };

  /*  Returns true or false depending if the browser
      is iOS or not
  */
  const isiOS = () => {
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      return true;
    }
    return false;
  };

  /*  This will stop ios scrolling the background
      instead of the top element
  */
  const iosScrollFix = elem => {
    const elemReturn = elem;
    if (elem.scrollTop < 1) {
      elemReturn.scrollTop = 1;
    } else if (elem.scrollHeight - elem.scrollTop - elem.clientHeight < 1) {
      elemReturn.scrollTop -= 1;
    }
    return elemReturn;
  };

  return {
    devLog,
    QAlog,
    foundSelectors,
    foundSelector,
    SelectorsReturned,
    classListMerged,
    isInViewport,
    hasClass,
    isiOS,
    iosScrollFix
  };
}());


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartNotMultiBuy: '[data-add-to-cart]:not(.product-details-multi-buy)',
    addToCartText: '[data-add-to-cart-text]',
    backToStock: '.klaviyo-bis-trigger',
    addToMultipleCart: '[data-add-to-cart-multiple]',
    addToMultipleCartText: '[data-add-to-cart-multiple-text]',
    productQuantity: '[data-product-qty]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    // This puts the inventory information into variants if its missing... (requires data "data-product-variant-inventory" [done in product.liquid])
    // inventory info is required for the BackOrder Button function...
    if ($(selectors.productInventoryJson, this.$container).html()) {
    	var productInventoryObject = JSON.parse($(selectors.productInventoryJson, this.$container).html());
      	//console.log("productInventoryObject value is:");
      	//console.log(productInventoryObject);
      	this.productSingleObject.variants.forEach(function(my_variant_obj){
          if(!my_variant_obj.hasOwnProperty('inventory_quantity')) {
            //console.log("Hang On....inventory_quantity property is missing....putting it back...");
            var my_inventory_obj = $.grep(productInventoryObject.variant_inventory, function(my_inventory_obj){return my_inventory_obj.id === my_variant_obj.id;})[0];
        	//var my_inventory_obj = productInventoryObject.variant_inventory.find(function (my_inventory_obj) { return my_inventory_obj.id === my_variant_obj.id; });
            //console.log("result of search: my_inventory_obj value is:");
        	//console.log(my_inventory_obj);
            if(my_inventory_obj !== undefined) {
      			$.extend( my_variant_obj, my_inventory_obj );
        		//console.log("Good news - found inventory_quantity - new my_variant_obj value is:");
        		//console.log(my_variant_obj);
            }
          }
      })
    }
    //console.log("product object value is NOW:");
    //console.log(this.productSingleObject);
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }



  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        // $(selectors.addToMultipleCart, this.$container).prop('disabled', true);
        // $(selectors.addToMultipleCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {

        $(selectors.addToCart, this.$container).prop('disabled', false);
        if (!variant.hasOwnProperty('inventory_quantity') || variant.inventory_quantity > 0){
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
          $(selectors.backToStock, this.$container).hide();
          $(selectors.addToCartNotMultiBuy, this.$container).css("background", theme.strings.cartBtnColor);

          //$(selectors.addToMultipleCart, this.$container).css("background", theme.strings.cartBtnColor);
          $(selectors.addToMultipleCartText, this.$container).html(theme.strings.addToMultipleCart);

        } else {
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart + "<br>[" + (typeof($('.product__addtocart-holder').data('preorder-text')) !== 'undefined'?$('.product__addtocart-holder').data('preorder-text'):theme.strings.backOrder)+"]");
          //$(selectors.addToCart, this.$container).css("background", theme.strings.cartBtnBackOrderColor);
        }
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.backToStock, this.$container).show();
        $(selectors.addToCartNotMultiBuy, this.$container).css("background", theme.strings.cartBtnSoldOutColor);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Toggles <video> src conditionally based on data attributes to
 * prevent wasted bandwidth when hidden.
 *
 * @requires vendo;r/lodash.throttle.js
 */

(function modVideoRespSrc() {
  var THROTTLE_WAIT_MS = 250;

  var selectors = {
    mediumUp: '[data-medium-up--src]',
    small: '[data-small--src]',
    all: '[data-src]',
    poster: '[data-poster]'
  };

  var mediumUp = 'only screen and (min-width: 750px)';

  function checkSrcs() {
    var $mediumUp;
    var $small;


    if (window.matchMedia(mediumUp).matches) {
      $mediumUp = $(selectors.mediumUp);

      $mediumUp.each(function eachMediumUp() {
        var src = $(this).attr('data-medium-up--src');
        var $video = $(this).closest('video');

        if (!$video.length || !src) {
          return;
        }

        $(this)
          .attr('src', src)
          .removeAttr('data-medium-up--src');

        $video[0].load();
        // eslint-disable-next-line no-console
        console.log('[video-responsive-src] loaded video src');
      });
    } else {
      $small =  $(selectors.small);
      $small.each(function eachSmall() {
        var src = $(this).attr('data-small--src');
        var $video = $(this).closest('video');

        if (!$video.length || !src) {
          return;
        }

        $(this)
          .attr('src', src)
          .removeAttr('data-small--src');

        $video[0].load();
        // eslint-disable-next-line no-console
        console.log('[video-responsive-src] loaded video src');
      });
    }

  }
  function initAllDevicesVideos() {
    $all =  $(selectors.all);
    $all.each(function eachAll() {
      var src = $(this).attr('data-src');
      var $video = $(this).closest('video');

      if (!$video.length || !src) {
        return;
      }

      $(this)
        .attr('src', src)
        .removeAttr('data-src');

      $video[0].load();
      // eslint-disable-next-line no-console
      console.log('[video-responsive-src] loaded video src');
    });
  }
  function posterChange() {
    $poster = $(selectors.poster);

    $poster.each(function eachAll() {
      var poster = $(this).attr('data-poster');
      if (!$(this).length || !poster) {
        return;
      }
      $(this)
        .attr('poster', poster)
        .removeAttr('data-poster');
    });
  }
  function init() {
    posterChange();
    checkSrcs();
    initAllDevicesVideos();
    $(window).on('resize', window.throttle(checkSrcs, THROTTLE_WAIT_MS));
  }
  init();
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Modules ================*/
/*

  Javascript based GeoIP service using the MaxMind JS API

  Usage:

  CREATE NEW INSTANCE
  -------------------

  var geoip = new GeoIPService();


  AVAILABLE METHODS
  -----------------

  1. Perform IP Lookup and show Popup:

  geoip.getLocation();

  2. Return Country Info only:

  geoip.countryLookup(function() {
    console.log(geoip.getCountryName());    // Returns the country name
    console.log(geoip.getCountryStore());   // Returns the store associated with their country e.g. UK, US, ROW etc
  });

*/

(function() {

  // early return if geoip settings aren't available

  if (!window.rfd || !window.rfd.geoip) {
    console.log('[GEOIP] no settings available');
    return;
  }

  var cookiesEnabled = window.rfd.geoip.enable_cookies;
  var redirectEnabled = window.rfd.geoip.enable_geoip;
  var overlayEnabled = window.rfd.geoip.display_country_select;
  var currentStore = window.rfd.geoip.geoip_current_store;
  var rowStore = window.rfd.geoip.geoip_row_store;
  var countryStore = window.rfd.geoip.geoip_current_country;
  var countryName = '';
  var cookieName = 'countryRedirect';
  var isLocalhost = window.location.hostname === 'localhost' ||
    window.location.hostname.indexOf('192.168.') !== -1;

  GeoIPService = (function() {

    /* Store Configuration */
    var stores = {
      'australia' : window.rfd.geoip.australia,
      'eu' : window.rfd.geoip.eu,
      'canada' : window.rfd.geoip.canada,
      'finland' : window.rfd.geoip.finland,
      'france' : window.rfd.geoip.france,
      'germany' : window.rfd.geoip.germany,
      'ireland' : window.rfd.geoip.ireland,
      'italy' : window.rfd.geoip.italy,
      'mexico' : window.rfd.geoip.mexico,
      'netherlands' : window.rfd.geoip.netherlands,
      'spain' : window.rfd.geoip.spain,
      'uk' : window.rfd.geoip.uk,
      'us' : window.rfd.geoip.us
    };

    /* Country to Store Configuration */
    var countries = {
      'US' : { 'Name':'USA', 'Store': 'us' },
      'CA' : { 'Name':'Canada', 'Store': 'canada' },
      'GB' : { 'Name':'United Kingdom', 'Store':'uk' },
      'FI' : { 'Name':'Finland', 'Store':'finland' },
      'DK' : { 'Name':'Denmark', 'Store':'eu' },
      'SE' : { 'Name':'Sweden', 'Store':'eu' },
      'NO' : { 'Name':'Norway', 'Store':'eu' },
      'AL' : { 'Name':'Albania', 'Store':'eu' },
      'AD' : { 'Name':'Andorra', 'Store':'eu' },
      'AT' : { 'Name':'Austria', 'Store':'germany' },
      'BY' : { 'Name':'Belarus', 'Store':'eu' },
      'BE' : { 'Name':'Belgium', 'Store':'eu' },
      'BA' : { 'Name':'Bosnia and Herzegovina', 'Store':'eu' },
      'BG' : { 'Name':'Bulgaria', 'Store':'eu' },
      'BR' : { 'Name':'Brazil', 'Store':'mx' },
      'HR' : { 'Name':'Croatia', 'Store':'eu' },
      'CO' : { 'Name':'Columbia', 'Store':'mx' },
      'CY' : { 'Name':'Cyprus', 'Store':'eu' },
      'CZ' : { 'Name':'Czech Republic', 'Store':'eu' },
      'EE' : { 'Name':'Estonia', 'Store':'eu' },
      'FO' : { 'Name':'Faroe Islands', 'Store':'uk' },
      'FR' : { 'Name':'France', 'Store':'france' },
      'DE' : { 'Name':'Germany', 'Store':'germany' },
      'GI' : { 'Name':'Gibraltar', 'Store':'eu' },
      'GR' : { 'Name':'Greece', 'Store':'eu' },
      'HU' : { 'Name':'Hungary', 'Store':'eu' },
      'IS' : { 'Name':'Iceland', 'Store':'eu' },
      'IE' : { 'Name':'Ireland', 'Store':'ireland' },
      'IT' : { 'Name':'Italy', 'Store':'italy' },
      'LV' : { 'Name':'Latvia', 'Store':'eu' },
      'LI' : { 'Name':'Liechtenstein', 'Store':'eu' },
      'LT' : { 'Name':'Lithuania', 'Store':'eu' },
      'LU' : { 'Name':'Luxembourg', 'Store':'eu' },
      'MK' : { 'Name':'Macedonia', 'Store':'eu' },
      'MT' : { 'Name':'Malta', 'Store':'eu' },
      'MD' : { 'Name':'Moldova', 'Store':'eu' },
      'MC' : { 'Name':'Monaco', 'Store':'eu' },
      'MX' : { 'Name':'Mexico', 'Store':'mx' },
      'NL' : { 'Name':'Netherlands', 'Store':'netherlands' },
      'PL' : { 'Name':'Poland', 'Store':'eu' },
      'PT' : { 'Name':'Portugal', 'Store':'eu' },
      'RO' : { 'Name':'Romania', 'Store':'eu' },
      'RU' : { 'Name':'Russia', 'Store':'us' },
      'SM' : { 'Name':'San Marino', 'Store':'eu' },
      'RS' : { 'Name':'Serbia', 'Store':'eu' },
      'SK' : { 'Name':'Slovakia', 'Store':'eu' },
      'SI' : { 'Name':'Slovenia', 'Store':'eu' },
      'ES' : { 'Name':'Spain', 'Store':'spain' },
      'CH' : { 'Name':'Switzerland', 'Store':'germany' },
      'UA' : { 'Name':'Ukraine', 'Store':'eu' },
      'VA' : { 'Name':'Vatican city', 'Store':'eu' },
      'IM' : { 'Name':'Isle of Man', 'Store':'uk' },
      'ME' : { 'Name':'Montenegro', 'Store':'eu' },
      'GG' : { 'Name':'Guernsey', 'Store':'uk' },
      'JE' : { 'Name':'Jersey', 'Store':'uk' },
      'AU' : { 'Name':'Australia', 'Store':'us' },
      'NZ' : { 'Name':'New Zealand', 'Store':'us' }
    };

    /* GeoIPService Constructor */
    function GeoIPService() { }

    /* GeoIPService Functions */
    GeoIPService.prototype = $.extend({}, GeoIPService.prototype, {

      // Perform GeoIP Lookup
      getLocation: function() {
        console.log('[GEOIP] performing lookup');
        if (this.getQueryStringParameter('gclid') || this.getQueryStringParameter('gclid') === undefined) {
          var cookied = this.getRedirectCookie();
          if (cookied) {
            if (isLocalhost) {
              console.log('[GEOIP] on localhost, skipping redirect');
              return;
            }

            if (cookied !== 'correct') {
              console.log('[GEOIP] getLocation redirecting to', cookied);
              window.top.location.href = cookied;
            } else {
              console.log('[GEOIP] no action required');
              return;
            }
          } else {
            geoip2.country(this.processResponse, this.processError);
          }
        }
      },

      // Process GeoIP Lookup Results and show appropriate popup
      processResponse: function(data) {

        var location = 'ROW';

        if (typeof(data.country.iso_code) !== 'undefined') {
          if (typeof(countries[data.country.iso_code]) !== 'undefined') {
            if (countries[data.country.iso_code]['Store'] !== currentStore) {
              location = countries[data.country.iso_code]['Store'];
            } else {
              console.log('[GEOIP] on the correct store', data.country.iso_code);
              return;
            }
          }
        }

        if (location === 'ROW') {
          location = rowStore;
        }

        // used for ROW results
        if (currentStore === location) {
          console.log('[GEOIP] on the correct store already', currentStore);
          return;
        }

        console.log('[GEOIP] suggesting location', location);
        showPopUpTwo(location);

      },

      // Process GeoIP Lookup Error
      processError: function(data) {
        // console.log("[GEOIP] fail - " + JSON.stringify(data, undefined, 4));
      },

      /* COUNTRY ONLY FUNCTION */

      // Perform IP lookup and return data
      countryLookup: function(callback) {
        var that = this; // I know…
        geoip2.country(
          function(data) {
            that.setCountry(data);
            if (callback) {
              callback();
            }
          },
          function(data) {
            that.processError(data);
            if (callback) {
              callback();
            }
          }
        );
      },

      // Store the Country Name and correct country store
      setCountry: function(data) {
        countryName = data.country.names.en;

        if (typeof(countries[data.country.iso_code]) !== 'undefined') {
          countryStore = countries[data.country.iso_code]['Store'];
        }
      },

      // Return the stores country name
      getCountryName: function(data) {
        return countryName;
      },

      // Return the stores country name
      getCountryStore: function(data) {
        return countryStore;
      },

      // Return the stores URL
      getCountryUrl: function(data) {
        return stores[countryStore];
      },

      /* HELPER FUNCTIONS */

      // Check for specified query string parameter
      getQueryStringParameter: function(parameter) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i=0; i < sURLVariables.length; i++) {
          var sParameterName = sURLVariables[i].split('=');
          if (sParameterName[0] == parameter) {
            return sParameterName[1];
          }
        }
      },

      // Check if the redirect cookie already exists
      getRedirectCookie: function() {
        console.log('[GEOIP] cookie val', Cookies.get(cookieName));
        if (Cookies.get(cookieName)) {
          var thisLocation =  window.location.host;
          var cookiedLocation = Cookies.get(cookieName);
          var cookieNoProtocol = cookiedLocation.replace("https://","").replace("http://", "").replace("\/", "");

          if (cookieNoProtocol == thisLocation) {
            return "correct";
          } else {
            return "https://" + cookieNoProtocol + window.location.pathname + window.location.search;
          }
        }
        return false;
      }

    });

    return GeoIPService;

  })();

  function getRedirectUrl(base) {
    return base + window.location.pathname + window.location.search;
  }

  // Show the popup to a client that is on the wrong store.
  // function showPopUpOne(suggested_region) {
  //   $('.country-select-ui').show();
  // }

  // Show the popup to a client that has no suggested store..
  function showPopUpTwo(go_to_store) {
    Cookies.set('countrySelector', true, { expires: 90, path: '/' });
    $(".country-select-ui-geoip .country-select-column li").hide();
    $(".stay-store li a[data-region-code='" + currentStore + "']").parent().show();
    $(".go-to-store li a[data-region-code='" + go_to_store + "']").parent().show();
    $('.country-select-ui-geoip').show();
  }

  function geoip_getRedirectUrl(base) {
    return base + window.location.pathname + window.location.search;
  }

  function geoip_redirect(url) {
    console.log('[GEOIP] geoip_redirect redirecting to', url);

    if (url.indexOf('//' + window.location.host) === -1) {
      if (cookiesEnabled) {
        Cookies.set('', url, { expires: 90, path: '/' });
      }

      var baseDomain = url;
      var fullDomain = geoip_getRedirectUrl(baseDomain);

      if (isLocalhost) {
        console.log('[GEOIP] on localhost, skipping redirect');
        return;
      }

      window.top.location.href = fullDomain;
    } else {
      console.log('[GEOIP] already on domain, skipping redirect');
    }
  }

  function handleOptionClick(e) {
    e.preventDefault();

    var baseDomain = $(this).attr("href");
    var fullDomain = getRedirectUrl(baseDomain);

    var isStay = $(this).parents('.stay-store').length;

    if (isStay) {
      Cookies.set('countryRedirect', window.location.host, { expires: 90, path: '/' });
      $('.country-select-ui-geoip').fadeOut(500);
      return;
    }

    if (cookiesEnabled) {
      Cookies.set('countryRedirect', $(this).attr("href"), { expires: 90, path: '/' });
    }

    if (window.location.href.search( baseDomain ) === -1) {
      window.top.location.href = fullDomain;
    } else {
      $('.country-select-ui-geoip').fadeOut(500);
    }
  }

  function setThisCountry() {
    Cookies.set('countrySelector', true, { expires: 90, path: '/' });
    Cookies.set('countryRedirect', window.location.host, { expires: 90, path: '/' });
  }
  function inIframe() {
      try {
          return window.self !== window.top;
      } catch (e) {
          return true;
      }
  }

  function init() {
    if (inIframe()) {
      console.log('[GEOIP] in iframe, disabling');
      return;
    }

    if (!redirectEnabled) {
      console.log('[GEOIP] disabled');
      return;
    }

    if (!window.geoip2) {
      console.log('[GEOIP] not available (skipping country selector)');
      return;
    }

    // query string '?country-selected=true' means user selected this store
    // explicitly from country menu (on another store) so don't show overlay,
    // just set cookie to this domain as user has already chosen it
    var isCountrySelected = (window.location.search.search('country-selected=true') !== -1);
    if (isCountrySelected) {
      console.log('[GEOIP] pre-chosen, setting store as selection');
      return setThisCountry();
    }

    var geoip = new GeoIPService();

    if (overlayEnabled) {

      $('.country-select-ui-geoip .country-select-column a').click(handleOptionClick);
      geoip.getLocation();

    } else if (redirectEnabled) {

      geoip.countryLookup(function() {
        console.log('[GEOIP] user in', geoip.getCountryName(), 'Correct store', geoip.getCountryStore());
        geoip_redirect(geoip.getCountryUrl());
      });

    }
  }

  $(document).ready(function() {
    init();
  });

}());



var $optionBox = '.option-box';
var $sizeDetail = $('#size-detail');
var $selectedItemSize = '';
var $selectOptions = $('.product__actions').children('.selector-wrapper.js');
var $Selects = $('.product__actions').children('.selector-wrapper.js').children('.option-wrapper');
var $ChosenProductChoice = '';
var $ChosenProductPrice = $('[data-product-price-toggle]');
var $ChosenProductComparePrice = $('[data-compare-price]');
var $currency = currencyData.moneyFormat;
var $currency = $currency.replace('{{amount}}', '').replace('{{amount_with_comma_separator}}','');
var product_json = $('[data-product-json-change]');

$(function () {

  if ($Selects.length > 0) {
    $.each($($optionBox + '.active'), function () {
      $selectedItemSize = $selectedItemSize + '' + $(this).data('value');
    });

    $sizeDetail.text('Size: ' + $selectedItemSize);
    product_json = JSON.parse($(product_json).html());
  }
});

$('.option-wrapper').on('click', $optionBox, function () {
  var $foundIt = false;
  var $this = $(this);
  var $parent = $('#' + $this.parent().data('option-parent'));
  var $target = 'option[data-option="' + $this.data('for-option') + '"]';
  var $value = $this.data('value');
  var $siblingoptionBox = $this.siblings();
  var $otherparent = $('.option-wrapper:not([data-option-parent="' + $this.parent().data('option-parent') + '"])');
  var $otherParentOptionBox = $otherparent.find('.option-box');

  $this.siblings().removeClass('active');
  $parent.find('option').attr('selected', false);
  $parent.find($target).attr('selected', true);
  $parent.change();
  $('.primaryactive').removeClass('primaryactive');
  $this.addClass('active primaryactive');

  if ($Selects.length > 1) {
    $otherParentOptionBox.each(function () {
      $found = false;
      $is_pre_order = false;
      $otherThis = $(this);
      $option1 = $value + ' / ' + $otherThis.data('value');
      $option2 = $otherThis.data('value') + ' / ' + $value;

      $(product_json.variants).each(function () {
        var current_var_title = this.title;
        var current_var_availability = this.available;
        var current_var_qty = this.inventory_quantity;
        var inventory_policy = this.inventory_policy;

        if (current_var_title === $option1 || current_var_title === $option2) {
          $found = true;

          if (current_var_qty < 1 && current_var_availability == true && inventory_policy == 'continue') {
            $is_pre_order = true;
          }
          if (current_var_availability == false && $is_pre_order != true) {
            $found = false;
          }
        }
      });

      $otherThis.removeClass('order strikethrough');

      if ($is_pre_order === true) {
        $otherThis.addClass('order');
      }

      if ($found === false) {
        $otherThis.addClass('strikethrough');
      }

    });
  }

  // removing classes for color changing
  if ($Selects.length > 1) {
    $siblingoptionBox.removeClass('order');
    $siblingoptionBox.removeClass('strikethrough');
    $Selects.each(function () {
      // when one option is chosen, it selects the first variant by default
      // this makes the front of the site reflect that
      var $thisSelectOptions = $(this).children('.option-box');
      if (!$thisSelectOptions.hasClass('active')) {
        var $thisSelectOptionsparent = $('#' + $this.parent().data('option-parent'));
        var $thisSelectOptionstarget = 'option[data-option="' + $this.data('for-option') + '"]';
        $thisSelectOptions.first().addClass('active');
        $thisSelectOptionsparent.find($thisSelectOptionstarget).attr('selected', true);
        $thisSelectOptionsparent.change();
      }
    });
  }

  $ChosenProductChoice = checkChoices();

  $(product_json.variants).each(function () {
    var current_var_title = this.title;

    if ($ChosenProductChoice == current_var_title) {
      $('[data-price-wrapper]').removeClass('hide');
      var current_var_price = this.price;
      var current_var_compareprice = this.compare_at_price;
      var current_var_qty = this.inventory_quantity;
      var current_inventory_policy = this.inventory_policy;
      var current_var_availability = this.available;
      var preorder_text = (typeof($('.product__addtocart-holder').data('preorder-text')) !== 'undefined')?$('.product__addtocart-holder').data('preorder-text'):theme.strings.preorder_prefix + ": " + theme.strings.preorder_msg_no_date;

      $foundIt = true;
      $ChosenProductPrice.text($currency + (current_var_price / 100).toFixed(2));

      if (current_var_compareprice == null) {
        $ChosenProductComparePrice.text('');
      } else {
        $ChosenProductComparePrice.text($currency + (current_var_compareprice / 100).toFixed(2));
      }

      if (current_var_qty < 1 && current_var_availability == true && current_inventory_policy == 'continue') {
        $foundIt = true;
        $('[data-add-to-cart-text]', this.$container).html(theme.strings.addToCart+"<br>["+preorder_text+"]");
        //$('[data-add-to-cart]', this.$container).css("background", theme.strings.cartBtnBackOrderColor);
        $('#addCart-preorder-info').removeAttr("disabled");
      } else {
        $('#addCart-preorder-info').attr("disabled", "disabled");
      }

      return false; //break the loop for performance
    }
  });

  if ($foundIt == false) {
    $('[data-price-wrapper]').addClass('hide');
  }


  $selectedItemSize = '';
  $.each($($optionBox + '.active'), function () {
    $selectedItemSize = $selectedItemSize + '' + $(this).data('value');
  });
  $sizeDetail.text('Size: ' + $selectedItemSize);
});

function checkChoices() {
  var opt0 = $('#SingleOptionSelector-0').first().val();
  var opt1 = $('#SingleOptionSelector-1').first().val();
  var opt2 = $('#SingleOptionSelector-2').first().val();

  //combine the selector values together (so we can match it to the actual the variant)
  if (opt0 != undefined && opt1 != undefined) {
    if (opt2 != undefined) {
      var combinedOpts = opt0 + ' / ' + opt1 + ' / ' + opt2;
    } else {
      var combinedOpts = opt0 + ' / ' + opt1;
    }
  } else {
    var combinedOpts = opt0;
  }
  return combinedOpts;
}

(() => {
  const module = 'blog';

  const selectors = {
    categorySelector: '#goToSelector'
  };
  const selectElement = document.querySelector(selectors.categorySelector);

  const init = () => {
    const foundSelectors = theme.helpers.foundSelectors(selectors);
    if (!foundSelectors) {
      return;
    }

    selectElement.addEventListener('change', event => {
      window.location = event.target.value;
    });
    theme.helpers.devLog(module, 'init');
  };

  // eslint-disable-next-line no-return-assign
  return (theme[module] = {
    init
  });
})();

(function() {
    $(document).ready(function() {
        $('body').on('click', '.trustspot-inline-rating', function () {
            $('html, body').animate({ 
              scrollTop: $('#trustspotWorldwideProductReviews').offset().top
            }, 0);
        });
    });    
})();
(function() {
    function setupVideo() {
      $('.main-gallery').each(function() {
        var galleryHeight = $(this).height();
        var mediaVideoWrapperElem = $(this).find('.media-video-wrapper-js');
        mediaVideoWrapperElem.css('padding-top', (galleryHeight - mediaVideoWrapperElem.height()) / 2 + 'px');
      });
    }

    $(document).ready(function(){
        var $imageGallery = $('.image-gallery ul');
        var $imageGalleryThumbs = $('.slider-nav-thumbnails');
        var $window = $('window');
        var breakpoint = 750;

        $imageGallery.on('init', function(){
          $imageGallery.parent().addClass('js-gallery-active');
          $imageGallery.closest('.image-gallery').removeClass('visibility-hidden');
        });

        $imageGallery.not('.slick-initialized').each(function() {
          $(this).slick({
            asNavFor: $(this).hasClass('isUserGallery') ? '.isUserGalleryThumbnails' : '.isProductGalleryThumbnails',
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0',
            adaptiveHeight: false,
            fade: false,
            lazyLoad: 'ondemand'
         });
        });
        $imageGalleryThumbs.not('.slick-initialized').each(function() {
            $(this).slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            asNavFor: $(this).hasClass('isUserGalleryThumbnails') ? '.isUserGallery' : '.isProductGallery',
            dots: false,
            arrows:false,
            focusOnSelect: true,
            responsive: [{
              breakpoint: breakpoint,
              settings: {
                vertical: false,
                verticalSwiping: false
              }
            }]
          });
        });

        if( $('.media-video-wrapper-js').length > 0 ) {
            setupVideo();
        }
    });
})();

var CookieShopify = Cookies.get('shopify_recently_viewed');
if (CookieShopify == undefined){
    $('.product-template__container.page-width.head-room').hide();
}

Shopify.Products = (function() {
  var config = {
    maxToShow: 8,
    minToShow: 4,
    howManyToStoreInMemory: 10,
    gallerySection: '[data-gallery-recently-section]',
    galleryContainer: '[data-gallery-recently]',
    gallerySlide: '.grid__item',
    onComplete: null
  };

  var initGallery = function() {
      if ($('#recently-viewed-products').length && $(window).width() < 768) {
        $('#recently-viewed-products').slick({
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 2
        });
      }
  };

  var productHandleQueue = [];

  var cookie = {
    configuration: {
      expires: 90
    },
    name: 'shopify_recently_viewed',
    write: function(recentlyViewed) {
      Cookies.set(this.name, recentlyViewed.join(','), this.configuration);
    },
    read: function() {
      var recentlyViewed = [];
      var cookieValue = Cookies.get(this.name);
      if (cookieValue) {
        recentlyViewed = cookieValue.split(',');
      }
      return recentlyViewed;
    },
    destroy: function() {
      Cookies.remove(this.name);
    },
    remove: function(productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var finalize = function() {
    var $gallerySection = $(config.gallerySection);
    if ($gallerySection.find(config.gallerySlide).length) {
      $gallerySection.show();
    }
    if (window.rfd && window.rfd.initAjaxCarousels) {
      window.rfd.initAjaxCarousels();
    }
    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {}
    }
    initGallery();
  };

  var getRecentProducts = function() {
    var searchRecentlyUrl;

    if (window.location.pathname.indexOf('/products/') !== -1) {
    var productHandle = window.location.pathname.match(
      /\/products\/([a-z0-9\-]+)/
    )[1];
    }

    productHandleQueue = productHandleQueue.filter(function(handle) {
      return productHandle !== handle;
    });
    if (productHandleQueue.length < config.minToShow) {
      return;
    }
    productHandleQueue.length = config.maxToShow;
    searchRecentlyUrl =
      '/search?view=recently&q=' + productHandleQueue.toString();
    $.get(searchRecentlyUrl, function(data) {
      $(config.galleryContainer)
        .empty()
        .append(data);
    }).done(function() {
      finalize();
    });
  };

  return {
    showRecentlyViewed: function(params) {
      var params = params || {};
      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();

      if (productHandleQueue === null || productHandleQueue === undefined) {
        return false;
      }

      config.maxToShow = Math.min(productHandleQueue.length, config.maxToShow);

      if (config.maxToShow) {
        getRecentProducts();
      }
    },

    getConfig: function() {
      return config;
    },

    clearList: function() {
      cookie.destroy();
    },

    recordRecentlyViewed: function(params) {
      var params = params || {};
      var recentlyViewed = cookie.read();
      var productHandle;
      var position;

      // Update defaults.
      jQuery.extend(config, params);

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {
        // What is the product handle on this page.
        productHandle = window.location.pathname.match(
          /\/products\/([a-z0-9\-]+)/
        )[1];
        // In what position is that product in memory.
        position = jQuery.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(
            0,
            config.howManyToStoreInMemory
          );
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    }
  };
})();
(function() {
  var inStockOptSelected = false;
  var preOrdOptSelected = false;
  var searchTemplateUrl = '/search?type=product&view=collection-filters-ajax&q=tag:"' + 'collection: ' + $('#collection-section').data('collection-handle') + '"+AND+tag:';
  var queryString = ''; // query string to request filters
  var ajaxRequestSent = false;
  var ajaxDisabled = false;

  function assembleSizeAndStockQuery(sizeOptionsArr, inStockOptSelected, preOrdOptSelected, queryString) {
    if(typeof sizeOptionsArr === 'undefined' || sizeOptionsArr.length < 1) return;

    var query = '';
    var sizesSelected = '';
    var instockQuery = '';
    var preorderQuery = '';

    if(inStockOptSelected) {
      for (i = 1; i <= sizeOptionsArr.length; i += 1) {
        if (sizeOptionsArr[i - 1].indexOf(':') > -1) {
          instockQuery += '"' + sizeOptionsArr[i-1].replace('e:','e_i:') + '"';
          if(i < sizeOptionsArr.length) instockQuery += '+OR+tag:';
        }
      }
    }

    if(preOrdOptSelected) {
      for (j = 1; j <= sizeOptionsArr.length; j += 1) {
        if (sizeOptionsArr[j - 1].indexOf(':') > -1) {
          preorderQuery += '"' + sizeOptionsArr[j-1].replace('e:','e_p:') + '"';
          if(j < sizeOptionsArr.length) preorderQuery += '+OR+tag:';
        }
      }
    }

    if(inStockOptSelected && preOrdOptSelected) {
      query = instockQuery + "+OR+" + preorderQuery + "+AND+" + queryString;
    } else if(inStockOptSelected) {
      query = instockQuery + "+AND+" + queryString;
    } else if(preOrdOptSelected) {
      query = preorderQuery + "+AND+" + queryString;
    }

    return query;
  }

  function assembleSizeOrStockQuery(sizeOptionsArr) {
    if(typeof sizeOptionsArr === 'undefined' || sizeOptionsArr.length < 1) return;

    var query = '';
    var sizesSelected = '';
    var stockOptsSelected = '';

    for(i = 1; i <= sizeOptionsArr.length; i += 1) {
      if(sizeOptionsArr[i-1].indexOf(':') > -1) {
        sizesSelected += '"' + sizeOptionsArr[i-1] + '"';
        if(i < sizeOptionsArr.length) sizesSelected += '+OR+tag:';
      }
    }

    if(sizesSelected != '') {
      query = sizesSelected;
    }

    return query;
  }

  function assembleStockOnlyQuery(inStockOptSelected, preOrdOptSelected) {
    if(typeof inStockOptSelected === 'undefined' || typeof preOrdOptSelected === 'undefined') return;

    var query = '';

    if(inStockOptSelected && preOrdOptSelected) {
      query = '"size_i"+OR+tag:"size_p"';
    } else if(inStockOptSelected) {
      query = '"size_i"';
    } else if(preOrdOptSelected) {
      query = '"size_p"';
    }

    return query;
  }

  function appendLabel(inStockOptSelected, preOrdOptSelected) {
    if(inStockOptSelected && $('.filter-tag-instock').length === 0) {

      var stockText = $('.in-stock-text').text();
      stockText = $.trim(stockText);

      $('.nav-group-size .filter-tags').append('<div href="#" class="filter-tag filter-tag-stock filter-tag-instock"><span class="filter-tag__text"> '+stockText+' </span><a href="#" class="filter-tag__remove">X</a></div>');

      $('.filter-tag-instock').on('click', function () {
        $('.inStockFilter').removeClass('active');
        getStockFilterItems('inStock');
        $(this).remove();
      });
    }
    if(preOrdOptSelected && $('.filter-tag-preorder').length === 0) {

      var prestockText = $('.pre-order-text').text();
      prestockText = $.trim(prestockText);

      $('.nav-group-size .filter-tags').append('<div href="#" class="filter-tag filter-tag-stock filter-tag-preorder"><span class="filter-tag__text"> '+prestockText+' </span><a href="#" class="filter-tag__remove">X</a></div>');

      $('.filter-tag-preorder').on('click', function () {
        $('.preOrderFilter').removeClass('active');
        getStockFilterItems('preOrder');
        $(this).remove();
      });
    }
  }

  function appendSizeLabel(dataTag) {
    var sizeSelected = dataTag.split('-')[1];

    if($('.filter-tag-size-' + sizeSelected).length === 0 ) {
      $('.nav-group-size .filter-tags').append('<div class="filter-tag filter-tag-size filter-tag-size-' + sizeSelected + '"><span class="filter-tag__text">Size ' + sizeSelected + '</span><a href="#" class="filter-tag__remove">X</a></div>');
      $('.filter-tag-size').on('click', function (e) {
        e.stopImmediatePropagation();
        $('.nav-group-size [data-tag-val="size-' + sizeSelected + '"]').parent().removeClass('active');
        getStockFilterItems();
        $(this).remove();
      });
    }
  }

  function requestFilterContent(searchTemplateUrl, queryString) {
    $('.filters-list').addClass('disabled-ul');
    if(!ajaxDisabled) {
      ajaxDisabled = true;
      $.get(searchTemplateUrl + queryString, function (data) {
        $('.collection-list').html($(data).find('.collection-list').html());
        $('.ajax-pag-cont').html($(data).find('.results__pagination').html());

        if (!ajaxRequestSent) {
          $('.ajax-pag-cont').on('click', '.js-ajax-pagination a', function (e) {
            e.preventDefault();
            var href = $(this).attr('href');
            requestFilterContent(href, "");
          });

          ajaxRequestSent = true;
        }
      }).done(function () {
        $('.filters-list').removeClass('disabled-ul');
        ajaxDisabled = false;
      });
    }
  }

  function getStockFilterItems(scenario) {
    var selectedSizeFiltersArr = []; //array of size options ticked
    var hasSizeOptionsSelected = false;
    var filterSelector = $('.mobile-sidebar').css('display') === 'none' ? $('.filter-container__desktop .nav-group-size li.active') : $('.mm-menu .nav-group-size li.active');

    filterSelector.each(function() {
      if($(this).data('tag') !== undefined) {
        selectedSizeFiltersArr.push($(this).find('a').data('tag-val').replace('-',':'));
        hasSizeOptionsSelected = true;
      } else {
        if($(this).hasClass('inStockFilter')) {
          inStockOptSelected = true;
        } else {
          preOrdOptSelected = true;
        }
      }
    });

    queryString = assembleSizeOrStockQuery(selectedSizeFiltersArr);

    if(typeof scenario !== 'undefined' && scenario === 'inStock') inStockOptSelected = false;
    if(typeof scenario !== 'undefined' && scenario === 'preOrder') preOrdOptSelected = false;

    if(hasSizeOptionsSelected && (inStockOptSelected || preOrdOptSelected)) {
      queryString = assembleSizeAndStockQuery(selectedSizeFiltersArr, inStockOptSelected, preOrdOptSelected, queryString);
      appendLabel(inStockOptSelected, preOrdOptSelected);
    } else if(!hasSizeOptionsSelected && !inStockOptSelected && !preOrdOptSelected) {
      if($('.nav-group li.active').length === 0) window.location.reload();
      if(window.currentNonSizeFilterUrl) {
        queryString = window.currentNonSizeFilterUrl.substring(8, window.currentNonSizeFilterUrl.length);
        requestFilterContent(searchTemplateUrl.replace('AND+tag:','AND+tag'), queryString);
      }
      appendLabel(inStockOptSelected, preOrdOptSelected);
    } else if(inStockOptSelected || preOrdOptSelected) {
      queryString = assembleStockOnlyQuery(inStockOptSelected, preOrdOptSelected);
      appendLabel(inStockOptSelected, preOrdOptSelected);
    }

    if(hasSizeOptionsSelected || inStockOptSelected || preOrdOptSelected) {
      window.currentSizeFilterUrl = searchTemplateUrl + queryString;
      if (window.currentNonSizeFilterUrl) queryString = queryString + currentNonSizeFilterUrl;
      requestFilterContent(searchTemplateUrl, queryString);
    }
  }

  $('[data-tag="size"]').on('click', function (event) {
    event.preventDefault();
    inStockOptSelected = false, preOrdOptSelected = false;
    $(this).toggleClass('active');
    getStockFilterItems();
    appendSizeLabel($(this).find('a').data('tag-val'));
    if(!$(this).hasClass('active')) {
      $('.filter-tag-' + $(this).find('a').data('tag-val')).remove();
    }
  });

  $('.stockFilter').on('click', function (event) {
    event.preventDefault();
    inStockOptSelected = false, preOrdOptSelected = false;
    $(this).toggleClass('active');
    getStockFilterItems();
    if(!$(this).hasClass('active')) {
      $(this).hasClass('inStockFilter') ? $('.filter-tag-instock').remove() : $('.filter-tag-preorder').remove();
    }
  });
})();

(function() {
  $(document).ready(function() { 
    //defensive checks   
    if( !$('body').hasClass('template-product') || !$('.shop-the-look').length ) return;
    if(typeof window.braSizesArray === 'undefined') return;
    
    var selectedOption = '';
    
    const buyTheLookBtn = $('#buy-the-look-btn');
    const braBandSizeInput = $('#bra-band-size');
    const braCupSizeInput = $('#bra-cup-size');
 
    function toggleButtonState() {
      if(braBandSizeInput.val() != 'default' && braCupSizeInput.val() != 'default') {
        buyTheLookBtn.removeAttr('disabled');
        buyTheLookBtn.html(buyTheLookBtn.data('shop-the-look-translate'));
      }

      if(braBandSizeInput.val() == 'default' || braCupSizeInput.val() == 'default') {
        buyTheLookBtn.attr('disabled','disabled');
        buyTheLookBtn.html(buyTheLookBtn.data('choose-size-translate')); 
      }
    }

  
    braBandSizeInput.on('change', function() {
     
      //select default option programmatically
      $('#bra-cup-size option[value=default]').prop('selected', true);
      //get selected option
      selectedOption = $('#bra-band-size option:selected').text().trim();
      //filter array
      var result = window.braSizesArray.filter(idx => idx.includes(selectedOption));
      $('#bra-cup-size option').show();
      $('#bra-cup-size option').each(function() {
        if( result.indexOf(selectedOption + $(this).attr('value') + "|in_stock") < 0 ){
          $('#bra-cup-size-' + $(this).attr('value')).attr("disabled", "");
        } else {
          $('#bra-cup-size-' + $(this).attr('value')).removeAttr("disabled");
        }
      }); 

      toggleButtonState();
    }); //end of on change function

    braCupSizeInput.on('change', function() {
      const cupSizeOption = $('#bra-cup-size option:selected');
      if (cupSizeOption.data('default') !== "default") {
        $('#product-select option[data-size=' + selectedOption + cupSizeOption.text().trim() + ']').prop('selected', true);
       
      } 
      toggleButtonState();
    }); //end of on change function
  });// end document ready function
})();

$(function() {
  theme.blog.init();
});

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register("product", theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = ".rte table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper"
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper"
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace(
      "supports-no-cookies",
      "supports-cookies"
    );
  }

  objectFitImages();
});
$(window).bind("load", function() {
  if ($(".rte__table-wrapper").length) {
    new SimpleBar($(".rte__table-wrapper")[0]);
  }
});
